import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ProjectConfigService } from '../services/project-config.service';

@Injectable({
  providedIn: 'root'
})
export class NotConstructionGuard implements CanActivate {

  constructor(
    private projectConfigService: ProjectConfigService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const config = this.projectConfigService.getConfig();
    if (!config.underConstruction) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}